module.exports = __webpack_public_path__ + "static/media/capgemini.e6cbdfd4.png";